import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { DateCheckValidator } from 'src/app/pages/user/user.util';
import * as moment from 'moment';
import { ExperiencesService } from '../../experiences.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-schedule-creation',
  templateUrl: './schedule-creation.component.html',
  styleUrls: ['./schedule-creation.component.css']
})
export class ScheduleCreationComponent implements OnInit {

  @Input() experienceForm: DVFormGroup;

  settings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    allowSearchFilter: false,
  };

  weekdays = moment.weekdays().map((v, i) => ({id: i + 1, name: v }));

  scheduleTypes = [];
  selectedItemsID = [];

  constructor(
    private experienceApi: ExperiencesService
  ) {
  }

  ngOnInit() {
    this.experienceForm.addDynamicAsyncValidator(new DateCheckValidator(['startDate', 'endDate'], 'Start Date should be after end date'));
    this.experienceApi.getAllExperienceTypes().subscribe(response => {
      this.scheduleTypes = response.data.experienceTypes;

    });
    this.experienceForm.controls.experienceTypes.valueChanges.subscribe(newValue => {
      this.updateSelectedIds(newValue);
    });
  }

  updateSelectedIds(selected) {
    this.selectedItemsID = selected.map(t => t.id);
  }

}
